import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    examData: null,
    attemptedQuestions: {},
    // ... other initial state values
};

export const examSlice = createSlice({
    name: 'exam',
    initialState,
    reducers: {
        setExamData: (state, action) => {
            state.examData = action.payload;
        },
        addAttemptedQuestion: (state, action) => {
            const { sectionIndex, questionIndex, attempt } = action.payload;
            if (!state.attemptedQuestions[sectionIndex]) {
                state.attemptedQuestions[sectionIndex] = [];
            }
            state.attemptedQuestions[sectionIndex][questionIndex] = attempt;
        },
        // ... other reducers for handling different actions
    },
});

// Export the action creators
export const { setExamData, addAttemptedQuestion } = examSlice.actions;

// Export the reducer
export default examSlice.reducer;
